import { register, CloudObject, defineProperty, defineRelation, Direction, File as OFile } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class Picture extends CloudObject { /* empty */ }

// Hardcoded tags
register('01880b4713e236081aaf', Picture);
Picture.picNameProp = defineProperty('018a981959b1188672fa');
Picture.rankProp = defineProperty('01880b47684c2a6d3317');
Picture.commentProp = defineProperty('01880b478845cdabd978');
Picture.fileRel = defineRelation('01880b47a75ed753793b', Picture, OFile);
Picture.inverse_inspectionEntitypicturesRel = defineRelation('01880b4800deb92600d6', Direction.ORIGIN);
Picture.inverse_assessmentconclusionPicturesRel = defineRelation('01880fbe8b7fffcc411f', Direction.ORIGIN);
Picture.inverse_assessmentintroductionPicturesRel = defineRelation('01880fbea854940b3dbe', Direction.ORIGIN);
Picture.inverse_generalInfopicturesRel = defineRelation('01880fc0803dc5691a43', Direction.ORIGIN);
Picture.inverse_observationpicturesRel = defineRelation('01880fc11345c99937b6', Direction.ORIGIN);
Picture.inverse_evaluationpicturesRel = defineRelation('01880fc6c31962221a15', Direction.ORIGIN);